import React, { memo } from 'react'
import { Grid, Stack } from '@mui/material'

import MilestoneProgress from '../shared/progressBar/MilestoneProgress'
import Text from '../shared/text/Text'
import { CURRENCIES } from '../../constants/app'
import {
  formatCurrencyValue,
  percentageOfCompletion
} from '../../util/numbers.helpers'
import { formatTicks } from '../../util/string.helpers'
import CustomTooltip from '../shared/customTooltip/CustomTooltip'
import DefaultText from '../shared/text/DefaultText'
// import TimeElapsed from './TimeElapsed'
// import { getContractConfig } from '../../util/app.helpers'

const DepositStatus = ({ t, mainProfile: { totalRaised, targetAmount } }) => {
  totalRaised = 214.659580377 // @TODO: Hard coded for now
  const totalDeposited = formatTicks(formatCurrencyValue(totalRaised))
  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={8}>
            <Stack spacing={1}>
              <Text
                variant='h2'
                label={t('home.deposit-status')}
                fontWeight={700}
              />
              <DefaultText label={t('home.deposit-status-desc')} />
              <CustomTooltip label={`${totalRaised} ${CURRENCIES.DEFAULT}`}>
                <Text
                  variant='h2'
                  label={`${totalDeposited} ${CURRENCIES.DEFAULT}`}
                  fontWeight={900}
                  sx={{ fontSize: 60, lineHeight: 'normal' }}
                />
              </CustomTooltip>
            </Stack>
          </Grid>
          <Grid item xs={12} sm={4}>
            {/* <TimeElapsed t={t} endTime={getContractConfig().end * 1000} /> */}
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <MilestoneProgress
          description={`${totalDeposited} / ${formatTicks(targetAmount)}`}
          completed={percentageOfCompletion(
            parseFloat(totalRaised),
            targetAmount
          )}
        />
      </Grid>
    </Grid>
  )
}

export default memo(DepositStatus)
